import React from 'react';
import { StyleSheet, View } from 'react-native';
import Theme, { fontStyles } from 'Theme';
import { Device } from 'DeviceUtils';
import { Background } from 'LocalGluons';
import { DETAIL_HEADER_HEIGHT } from './Menu/Menu.styles';

const getDrawerWidth = () => {
    let width = Device.width - Theme.BU * 7;
    if (Device.isTablet) {
        width = 330;
    } else if (Device.orientation !== 'PORTRAIT') {
        width = Device.height - Theme.BU * 7;
    }

    return width;
};

export const headerTitleStyle = {
    fontFamily: Theme.ultraFont,
    /*
     * Fix weird font weight on android, we must explicitly say it is 'normal'.
     * Probably issue with react-navigation styles
     */
    fontWeight: Device.isIos ? '900' : 'normal',
    fontSize: 26,
    textAlign: 'center',
    color: Theme.primaryTextColor
    // alignSelf: 'center'
};

export const navigationStyles = StyleSheet.create({
    headerTitleStyle,
    headerTitleStyleNormalWeight: {
        ...fontStyles.navigationHeader,
        fontWeight: 'normal'
    },
    headerStyle: {
        borderBottomColor: 'rgba(255,255,255,0.16)',
        backgroundColor: Theme.appHeaderBackgroundColor,
        borderBottomWidth: 1
    }
});

export const navigationStylesWeb = StyleSheet.create({
    headerStyle: {
        alignContent: 'center',
        backgroundColor: Theme.primaryBackgroundColor,
        width: '100%',
        marginTop: DETAIL_HEADER_HEIGHT,
        transition: 'height .16s linear',
        flexDirection: 'row',
        borderBottomColor: 'rgba(255,255,255,0.16)',
        borderBottomWidth: 1,
        paddingBottom: 15,
        color: 'red'
    },
    headerBackgroundContainerStyle: {
        transition: 'height .16s linear',
        color: 'yellow'
        // marginTop: 300,
        // backgroundColor: Theme.appHeaderBackgroundColor,
    }
});

export const topTabBarOptions = {
    tabBarPosition: 'top',
    position: 'top',
    screenOptions: {
        presentation: 'card',
        animation: 'fade',
        lazy: true,
        lazyPlaceholder: () => <Background />,
        swipeEnabled: false,
        tabBarStyle: {
            backgroundColor: Theme.primaryBackgroundColor,
            borderBottomColor: 'rgba(255, 255, 255, .25)',
            borderBottomWidth: 0.25
        },
        tabBarIndicatorStyle: {
            borderBottomColor: Theme.primaryTextColor,
            borderBottomWidth: 2
        },
        tabBarLabelStyle: {
            fontSize: 16,
            fontFamily: Theme.boldFont
        },
        tabBarActiveTintColor: Theme.primaryTextColor,
        tabBarInactiveTintColor: Theme.secondaryTextColor
    }
};

export const topTabBarOptionsWeb = {
    tabBarPosition: 'top',
    position: 'top',
    screenOptions: {
        tabBarStyle: { backgroundColor: 'rgba(80, 80, 80, 0.5)', height: 52, zIndex: 2 },
        tabBarLabelStyle: {
            fontSize: 15,
            fontFamily: Theme.boldFont,
            color: Theme.primaryTextColor,
            marginBottom: 12,
            marginHorizontal: 20
        }
    },
    activeBackgroundColor: Theme.primaryTextColor,
    inactiveBackgroundColor: 'transparent',
    inactiveLabelStyle: {
        fontSize: 15,
        fontFamily: Theme.regularFont,
        color: Theme.primaryTextColor,
        opacity: 0.5,
        marginBottom: 12,
        marginHorizontal: 20
    },
    labelStyle: {
        fontSize: 15,
        fontFamily: Theme.boldFont,
        color: Theme.primaryTextColor,
        marginBottom: 12,
        marginHorizontal: 20
    }
};

export const topTabBarOptionsWebInStack = {
    showBackButton: true,
    position: 'top',
    style: {
        backgroundColor: 'rgba(80, 80, 80, 0.5)',
        height: 52,
        zIndex: 2,
        position: 'absolute'
    },
    activeBackgroundColor: Theme.primaryTextColor,
    labelStyle: {
        fontSize: 16,
        fontFamily: Theme.regularFont,
        color: Theme.primaryTextColor,
        marginBottom: 12,
        marginHorizontal: 20
    }
};

export const topMenuOptions = {
    animationEnabled: !Device.isWeb,
    indicatorStyle: {
        borderBottomColor: Theme.primaryTextColor,
        borderBottomWidth: 3
    },
    tabBarOptions: {
        position: 'top',
        style: {
            zIndex: 3
        }
    },
    labelStyle: {
        fontSize: 14,
        fontFamily: Theme.boldFont,
        width: 400
    },
    lazy: true,
    lazyPlaceholder: () => <Background />
};

export const drawerOptions = {
    drawerWidth: getDrawerWidth(),
    overlayColor: 'rgba(0, 0, 0, 0)',
    drawerBackgroundColor: 'rgba(0,0,0,0.9)',
    lazy: true,
    headerShown: true,
    headerStyle: navigationStyles.headerStyle,
    headerTintColor: Theme.primaryTextColor,
    headerTitleStyle: navigationStyles.headerTitleStyle,
    cardStyle: { flex: 1, overflow: 'auto', backgroundColor: Theme.primaryBackgroundColor },
    headerTitleContainerStyle: {
        width: '100%',
        flex: 10
    },
    headerLeftContainerStyle: { flex: 1 },
    headerRightContainerStyle: { flex: 1 },
    drawerStyle: {
        backgroundColor: 'rgba(0,0,0,0.9)',
        width: getDrawerWidth(),
        paddingTop: 60
    },
    drawerType: 'front',
    presentation: 'card',
    animation: 'fade'
};
